import { useMutation } from "@apollo/client";

import { MapEditorEcologicalFunctionPanel_EcologicalFunctionObservationCreateDocument } from "./mutations.generated";
import { MapEditorEcologicalFunctionPanelEcologicalFunctionEditableDocument } from "./queries.generated";

export function useLinkObservationToEcologicalFunctionMutation() {
    const [mutate, result] = useMutation(MapEditorEcologicalFunctionPanel_EcologicalFunctionObservationCreateDocument, {
        refetchQueries: [MapEditorEcologicalFunctionPanelEcologicalFunctionEditableDocument],
    });

    const linkObservationToEcologicalFunction = (ecologicalFunctionId: string, observationId: string) =>
        mutate({
            variables: {
                input: {
                    ecologicalFunctionId,
                    observationId,
                },
            },
        });

    return [linkObservationToEcologicalFunction, result] as const;
}
